<af-main-container #mainContainer
                   [title]="'i18n_lib_breadcrumb#FaqDetails' | translate: {id: faqId}"
                   [showBackButton]="true"
                   [tabPathToTab]="tabPathToTab"
                   [buttonSpinnerId]="'save'"
                   [breadcrumbCustomizer]="breadcrumbCustomizer">

    <div CustomTitle class="w-100 mr-16 ml-16" fxLayout="row" fxLayoutAlign="space-between center" fxFlex>
        @if (faq) {
            <af-status [statusText]="'i18n_af_faqStatus#' + faq.status" [status]="statusStyle"/>
        }
        <div class="w-100" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="16px">
            <ui-kit-svg class="i-24 pointer c-primary-green-800" name="ic_edit" [matTooltip]="'i18n_af_labelEdit' | translate"
                        (click)="editFaq()"/>
            <ui-kit-svg class="i-24 pointer c-primary-green-800" name="ic_delete" [matTooltip]="'i18n_af_labelDelete' | translate"
                        (click)="deleteFaq()"/>
        </div>
    </div>

    <div class="details-container" fxLayout="column" fxLayoutAlign="start start">
        <div class="t2-semi-bold c-main-gray-900">{{ 'i18n_af_labelFaqCommonDetails' | translate }}</div>
        <div class="common-info-container">
            @for (field of commonFieldInfo; track field) {
                <div class="t2 c-primary-gray-600"> {{ 'i18n_af_label_field_faq#' + field.fieldName | translate }}</div>
                <div class="t2 c-primary-gray-900"> {{ field.fieldValue }}</div>
            }
        </div>
        <div class="question-answer-info-container">
            @for (field of qaFieldInfo; track field) {
                <div class="t2 c-primary-gray-600"> {{ 'i18n_af_label_field_faq#' + field.fieldName | translate }}</div>
                <div class="t2 c-primary-gray-900" [innerHTML]="field.fieldValue | safeHtml"></div>
            }
        </div>
    </div>
</af-main-container>
